module.exports = __webpack_public_path__ + "img/vignettes-asso_0010_fondation-jerome-lejeune.24f722b7.jpg";